import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../PartnerOptions/constants'

import AddMailboxEpic from './Management/AddMailbox/epics'
import managementEpics from './Management/epics'
import segmentsEpics from './Segments/epics'
import uploadEpics from './Upload/epics'
import userReportEpics from './UserReport/epics'
import {
  asGDError,
  asGDSuccess,
  asO365Error,
  asO365Success,
  fetchDataError,
  fetchDataSuccess,
  fetchSegmentsError,
  fetchSegmentsSuccess,
} from './actions'
import { AS_GD_ASYNC, AS_O365_ASYNC, DATA_REQUEST_ASYNC, SEGMENTS_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(DATA_REQUEST_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.self) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getInfo(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => fetchDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
        .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
    )

const fetchSegmentsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(SEGMENTS_REQUEST_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.self) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getSegments(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => fetchSegmentsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchSegmentsError, error)))
        .takeUntil(action$.ofType(SEGMENTS_REQUEST_ASYNC.CANCEL))
    )

const asO365Epic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(AS_O365_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .asO365(store.getState().partnerOptions.selectedCompany?.value, action.payload.body || {})
      .map((response) => asO365Success(response))
      .catch((error) => Observable.of(epicsErrorHandler(asO365Error, error)))
      .takeUntil(action$.ofType(AS_O365_ASYNC.CANCEL))
  )

const asGDEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(AS_GD_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .asGD(store.getState().partnerOptions.selectedCompany?.value, action.payload.body || {})
      .map((response) => asGDSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(asGDError, error)))
      .takeUntil(action$.ofType(AS_GD_ASYNC.CANCEL))
  )

export default combineEpics(
  combineEpics(fetchDataEpic, fetchSegmentsEpic, asO365Epic, asGDEpic),
  uploadEpics,
  managementEpics,
  segmentsEpics,
  AddMailboxEpic,
  userReportEpics
)
